import BlLoadingDialogMv from './BlLoadingDialogMv.vue'

BlLoadingDialogMv.install = function(Vue) {
  Vue.component(BlLoadingDialogMv.name, BlLoadingDialogMv)
}

export default BlLoadingDialogMv
